import React from "react";

import { HeaderSize } from "../../Constants/global";

const Blogs = () => {
  return <div style={{ paddingTop: HeaderSize.BottomPad }}>Welcome to blogs page!</div>;
};

export default Blogs;
